import { useEffect } from "react";
import { useNavigate } from "react-router";

const _props = {
    path: ''
}

export function Redirect(props = _props) {
    const navigate = useNavigate();

    useEffect(() => {
        if (props.path)
            navigate(props.path)
    }, [])

    return null
}